import { createAsyncThunk } from '@reduxjs/toolkit';
import { AdminRepository } from 'repositories/AdminRepository';
import { IAdminEquipmentGroupsState } from 'store/slices/adminEquipmentGroupsSlice';
import { IAuthState } from 'store/slices/authSlice';
import { IAdminEquipmentGroup, TAdminEquipmentGroupsQuery } from 'types';
import { EApiResponseStatus, IApiResponseDetails } from 'types/api';

export const fetchEquipmentGroups = createAsyncThunk<
  { content: IAdminEquipmentGroup[]; details: IApiResponseDetails },
  void,
  { state: { auth: IAuthState; adminEquipmentGroups: IAdminEquipmentGroupsState } }
>('adminEquipmentGroups/fetchEquipmentGroups', async (_, { getState }) => {
  const {
    auth: { token },
    adminEquipmentGroups: {
      currentPage,
      itemsPerPage,
      sortBy,
      sortDir,
      search,
      hourlyFrom,
      hourlyTo,
      weeklyFrom,
      weeklyTo,
      dailyFrom,
      dailyTo,
      testFrom,
      testTo,
    },
  } = getState();
  if (!token) throw Error('no token');

  const params: TAdminEquipmentGroupsQuery = {
    page: String(currentPage),
    size: String(itemsPerPage),
  };
  if (sortBy) {
    const newSortBy = sortBy === 'equipmentId' ? 'deviceId' : sortBy.replace(/Name$/, 'Id');
    params.sort = sortDir ? `connectiongroup.${newSortBy},${sortDir.toLowerCase()}` : newSortBy;
  }
  if (search) params.filter = search;
  if (hourlyFrom) params.hourlyfrom = hourlyFrom;
  if (hourlyTo) params.hourlyto = hourlyTo;
  if (weeklyFrom) params.weeklyfrom = weeklyFrom;
  if (weeklyTo) params.weeklyto = weeklyTo;
  if (dailyFrom) params.dailyfrom = dailyFrom;
  if (dailyTo) params.dailyto = dailyTo;
  if (testFrom) params.testfrom = testFrom;
  if (testTo) params.testto = testTo;

  const adminEquipmentGroupsResponse = await AdminRepository.getEquipmentGroups(token, params);

  if (adminEquipmentGroupsResponse.status === EApiResponseStatus.FAILURE) {
    throw Error(adminEquipmentGroupsResponse.error);
  }

  return adminEquipmentGroupsResponse.data;
});

export const fetchExportEquipmentGroups = createAsyncThunk<
  { exportData: string },
  void,
  { state: { auth: IAuthState } }
>('adminEquipmentGroups/fetchExportEquipmentGroups', async (_, { getState }) => {
  const {
    auth: { token },
  } = getState();

  if (!token) throw Error('no token');

  const adminExportEquipmentGroupsResponse = await AdminRepository.getEquipmentGroupsExport(token);

  if (adminExportEquipmentGroupsResponse.status === EApiResponseStatus.FAILURE) {
    throw Error(adminExportEquipmentGroupsResponse.error);
  }

  return {
    exportData: adminExportEquipmentGroupsResponse.data,
  };
});
